// MEGA MENU
// function mmMegaMenuShowProducts(classElemsToHide, classElemToShow) {
//   var imageContainers = document.querySelectorAll(classElemsToHide);
//   imageContainers.forEach(function(imageContainer){
//     imageContainer.style.display = 'none';
//   })
//   document.querySelector(classElemToShow).style.display = 'grid';
// }

function getMegaMenuPosition(){
  var menuElems = document.querySelectorAll('.mm-header-link');

  menuElems.forEach(function(menuElem){
    var viewportOffset = menuElem.getBoundingClientRect();
    var top = viewportOffset.top;
    if (menuElem.nextElementSibling != null && menuElem.nextElementSibling.classList.contains("mm-mega-menu-wrapper")) {
		menuElem.nextElementSibling.style.top = "calc(" + top + "px)";
	}
  })
}

document.addEventListener("DOMContentLoaded", (event) => {
  getMegaMenuPosition();
});

// MOBILE MENU
function mmMobileMenu() {
    const header = document.querySelector("header");
    const icon = document.querySelector(".mm-header-burger");
  const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");
    document.querySelector("html").classList.toggle("stop-scrolling");
    document.querySelector("body").classList.toggle("stop-scrolling");

    header.classList.toggle("mm-open");
    icon.classList.toggle("mm-open");
    mobileMenu.classList.toggle("mm-menu-open");
    mobileMenu.style.top = header.getBoundingClientRect().bottom + "px";
}

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector("product-recommendations");

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }

                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
}

customElements.define("product-recommendations", ProductRecommendations);
function animatedDropdowns(){
  const faqColl = document.querySelectorAll('.mm-faq-collapsible');
  let q;

  for (q = 0; q < faqColl.length; q++) {
      faqColl[q].addEventListener('click', function () {
          this.classList.toggle('active');

          const content = this.nextElementSibling;

          if (content.style.maxHeight) {
              content.style.maxHeight = null;
          } else {
              content.style.maxHeight = content.scrollHeight + 'px';
          }
      });
  }
}

window.addEventListener("DOMContentLoaded", (event) => {
  animatedDropdowns();
});

/* mobile drawer height */
const documentHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', documentHeight)
documentHeight()


function mmToggleSeachBar(icon) {
	icon.nextElementSibling.classList.toggle("mm-active");
}

/* Product Card */
class QuantitySwatch extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest(".mm-product-card");
		this.addEventListener("change", this.onVariantChange);
	}

	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updatePrice();
			this.updateFormID();
		}
	}

	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-card-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	getVariantJSON() {
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);
			if (findings) return variant;
		});
	}

	updateFormID() {
		const form_input = this.querySelector(".mm-product-card-variant_id");
		form_input.value = this.currentVariant.id;
	}

	updatePrice() {
		const price = this.container.querySelector(".mm-product-card-price");
		var new_price = (this.currentVariant.price / 100).toFixed(2);
		price.innerHTML = new_price.replace(".", ",") + "€&nbsp;";

		const compare_at_price = this.container.querySelector(".mm-pr-price-compare");

		const meta_img_container = this.container.querySelector(".mm-pc-img-meta-container");
		const meta_img = meta_img_container.querySelector(".mm-pill-color");

		if (this.currentVariant.compare_at_price > 0) {
			var new_compare_at_price = (this.currentVariant.compare_at_price / 100).toFixed(2);
			compare_at_price.innerText = new_compare_at_price.replace(".", ",") + "€";
			compare_at_price.style.textDecoration = "line-through";

			if (meta_img !== null) {
				meta_img.innerText = "-" + Math.round(((new_compare_at_price - new_price) / new_compare_at_price) * 100) + "%";
			}
		} else {
			compare_at_price.innerText = "";

			if (meta_img !== null) {
				const data_tag = meta_img_container.dataset.tag;
				if (data_tag !== "") {
					meta_img.innerText = data_tag;
				} else {
					meta_img.innerText = "";
				}
			}
		}
	}
}

customElements.define("quantity-variant", QuantitySwatch);
